import { render, staticRenderFns } from "./ActivityLog.vue?vue&type=template&id=60bf7014&"
import script from "./ActivityLog.vue?vue&type=script&lang=ts&"
export * from "./ActivityLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports